import React, { useState, useEffect, useRef } from 'react';
import ContactField from './field';
import { useSelector } from 'react-redux';
import Icon from '../../../../assets/icons/icon';
import { useDispatch } from 'react-redux';
import { setHasTriedMicPermission, setMicPermissionError , setMicPermissionModalLocked} from '../../../../features/callPermissionErrorSlice';

function ContactInfo({handleLeadData, makeDial, setisLeadNumberInValid}) {
    const numberList=useSelector((state) => state.agent.phoneNumbers);
    const [isOpen, setIsOpen] = useState(true);
    const numbers=['borrower_cell', 'borrower_home', 'borrower_work']
    const names=['borrower_first', 'borrower_last']
    const Conumbers=['co_borrower_cell', 'co_borrower_home', 'co_borrower_work']
    const Conames=[ 'co_borrower_first', 'co_borrower_last']
    const [innerWrapperHeight, setInnerWrapperHeight] = useState(0);
    const dispatch = useDispatch();
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);

    const ringState = useSelector((state) => state.call.ringState);
    const sessionStarted = useSelector((state) => state.call.sessionStarted);
    const isCallInProgress = ringState.toLowerCase() !== 'disconnected'
    const isDialingRef = useRef(false); 

    const innerWrapperRef = useRef(290);
    const openUp = () => {
        setIsOpen(!isOpen);
    };
    const startDial= async(toNum,callee,caller)=>{
        if (isDialingRef.current) return;
            isDialingRef.current = true;

        try {
            await navigator.mediaDevices.getUserMedia({ audio: true });
            dispatch(setMicPermissionError(false));  
            dispatch(setMicPermissionModalLocked(false));
        } catch (err) {
            dispatch(setMicPermissionError(true));
            dispatch(setHasTriedMicPermission(true));
            return;
        }

        //forcing the call logging int othe notes - reason is because if the lead connects, and the agent adds notes, it will overwrite the backend call logging. and if nothign happens, then the backend will be used.
        const timestamp = new Date().toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '');
        const newNotes=`Outbound Call - ${timestamp} <br> ${leadsAlldata?.notes}`;
        handleLeadData('notes', newNotes);
        const foundNumber = numberList.find(item => {
            return item.number === caller;
        });
        if(toNum.toString().length != 10){
            setisLeadNumberInValid(true);
        }else{
            setisLeadNumberInValid(false);
        if(foundNumber){
            makeDial(toNum,callee,caller)
        }
        else{
            caller=numberList[0].number;
            makeDial(toNum,callee,caller)
        }
        }
   
     setTimeout(() => {
        isDialingRef.current = false;
    }, 500);
    }

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (innerWrapperRef.current) {
                setInnerWrapperHeight(innerWrapperRef.current.clientHeight);
            }
        }, 250);
        return () => clearTimeout(timeoutId);

    }, [isOpen]);
    return (
        <div className={`quilityNestedBlockWrapper ${isOpen ? '' : ''}`} style={{overflow: "hidden"}} >
            <div className="quilityNestedBlockHeader " onClick={()=>openUp()}>
                <div className="quilityParentBlockTitle">Contact Information </div>
                <span className={`quilityBlockIcon ${isOpen ? 'rotate':''}`} style={{marginTop: '-5px', transition:'all .5s'}}><span className="fontello"><Icon name={'q-up'} size={20} className="closeIcon" adjust="fontello" /></span></span>
            </div>
            <div className="quilityNestedBlockContent" style={{ height: isOpen ? innerWrapperHeight + 25 : '0px' }}>
                <div className="innerWrapper" ref={innerWrapperRef}>

                        {names.map((field, index) => (
                            <div className="leadCardBlock doubleLine" key={`contactInfoNames${index}`}>
                                <ContactField handleLeadData={handleLeadData} field={field} key={`fieldInfo${index}`}/>
                            </div>
                        ))}
                        {numbers.map((field, index) => (
                            <span key={`numbersInfo${index}`}>
                                {leadsAlldata[field] !== null ? (
                                    <div className="leadCardBlock doubleLine">
                                        <span 
                                                className={`callIcon ${isCallInProgress || isDialingRef.current ? 'disabled' : ''}`}
                                                onClick={(event) => {
                                                    if (!isCallInProgress && !isDialingRef.current) {
                                                    startDial(leadsAlldata[field], leadsAlldata?.borrower_first + ' ' + leadsAlldata?.borrower_last, leadsAlldata?.call_from);
                                                    event.stopPropagation();
                                                    }
                                                }}
                                         >
                                            <span className="fontello" style={{height: '27px'}}><Icon name={'q-phone-call-outgoing'} size={18} className="" adjust="fontello" /></span>
                                            <div className="numberOptions">
                                                {numberList.map((number, index) => (
                                                    <span key={`availableNumbers${index}`}>
                                                    {leadsAlldata[field]===leadsAlldata.callFrom ? (
                                                        <div className="numberChoice" onClick={(event)=>{startDial(leadsAlldata[field],leadsAlldata?.borrower_first+' '+ leadsAlldata?.borrower_last,number.number);event.stopPropagation();}}>{number.friendlyName}</div>
                                                    ) : (
                                                        <div className="numberChoice" onClick={(event)=>{startDial(leadsAlldata[field],leadsAlldata?.borrower_first+' '+ leadsAlldata?.borrower_last,number.number);event.stopPropagation();}}>{number.friendlyName}</div>
                                                    )}
                                                    </span>

                                                ))}
                                            </div>
                                        </span>
                                        <ContactField handleLeadData={handleLeadData} field={field} key={`numbers_contact_field_${index}`} />
                                    </div>
                                ) : (
                                    <div className="leadCardBlock doubleLine">
                                        <ContactField handleLeadData={handleLeadData} field={field} key={`numbers_contact_field_${index}`} />
                                    </div>
                                )}
                            </span>
                        ))}
                         <div className="leadCardBlock doubleLine">
                            <ContactField key='email_contact_field' handleLeadData={handleLeadData} field='email' index='1'/>
                        </div>

                        {Conames.map((field, index) => (
                            <div className="leadCardBlock doubleLine" key={`contactInfoCoName${index}`}>
                                <ContactField handleLeadData={handleLeadData} field={field} key={`coNameFieldInfo${index}`}/>
                            </div>
                        ))}
                        {Conumbers.map((field, index) => (
                            <div className="leadCardBlock doubleLine" key={`contactInfoCoNumber${index}`}>
                                <ContactField handleLeadData={handleLeadData} field={field} key={`coNumberFieldInfo${index}`}/>
                            </div>
                        ))}
                        <div className="leadCardBlock doubleLine">
                            <ContactField key='co_borrower_email_contact_field' handleLeadData={handleLeadData} field='co_borrower_email' index='1'/>
                        </div>
                </div>
            </div>
        </div>
    );

}

export default ContactInfo;